import CustomSelect from "./CustomSelect";
import Input from "./Input";
import Select from "./Select";
import Select2 from "./Select2";
import Checkbox from "./Checkbox";
import { useState } from "react";

const Filter = (props) => {
  const fields = props.filterList;
  const handler = props.handler;
  const [checked, setChecked] = useState(true);
  function handleChange(e) {
    setChecked(!checked);
    handler.state.setFilter((prevState) => {
      return {
        ...prevState,
        [e.target.name]: !e.target.checked,
      };
    });
  }

  // const handleCheckboxChange = (e) => {
  //   handler.checkedBox.setIsChecked(!handler.checkedBox.isChecked);
  //   handler.state.setFilter((prevState) => {
  //     return {
  //       ...prevState,
  //       [e.target.name]: e.target.checked ? 1 : 0,
  //     };
  //   });
  // };

  const handleCheckboxChange = (e) => {
    const name = e.target.name;
    const checked = e.target.checked;

    if (handler.checkedBox?.[name]) {
      handler.checkedBox[name].setIsChecked(checked);
    }

    // Filter state update
    handler.state.setFilter((prevState) => ({
      ...prevState,
      [name]: checked ? 1 : 0,
    }));
  };

  // const handleInput = (e) => {
  //   switch (e.target.name) {
  //     case "from_date":
  //       handler.state.setFilter((prevState) => {
  //         return {
  //           ...prevState,
  //           [e.target.name]: e.target.value,
  //         };
  //       });
  //       handler.state.setFilter((prevState) => {
  //         return {
  //           ...prevState,
  //           to_date: e.target.value,
  //         };
  //       });
  //       break;

  //     default:
  //       handler.state.setFilter((prevState) => {
  //         return {
  //           ...prevState,
  //           [e.target.name]: e.target.value,
  //         };
  //       });
  //       break;
  //   }
  // };

  const handleInput = (e) => {
    const { name, value } = e.target;
    handler.state.setFilter((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleAsyncInput = (name, value) => {
    handler.state.setFilter((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  return (
    <>
      {/*border rounded-3 py-3 px-2 my-3*/}
      <div className={`row mb-4 ${props.show ? "" : "d-none"}`}>
        {fields.map((field) => (
          <>
            {field.visible !== false && (
              <>
                {["text", "date"].includes(field.type) && (
                  <Input
                    data={field}
                    state={handler.state.filter}
                    handleInput={handleInput}
                  />
                )}
                {["select"].includes(field.type) && (
                  <Select
                    data={field}
                    state={handler.state.filter}
                    handleInput={handleInput}
                  />
                )}
                {["select-dropdown"].includes(field.type) && (
                  <CustomSelect
                    data={field}
                    state={handler.state.filter}
                    handleInput={handleInput}
                    locationDate={props.locationDate}
                  />
                )}
                {["async_select"].includes(field.type) && (
                  <Select2
                    data={field}
                    state={handler.state.filter}
                    handleInput={handleAsyncInput}
                    locationDate={props.locationDate}
                    fields={props?.filter}
                  />
                )}
                {["checkbox"].includes(field.type) && (
                  <Checkbox
                    data={field}
                    state={handler.state.filter}
                    handleInput={handleCheckboxChange}
                    // isChecked={handler.checkedBox.isChecked}
                    isChecked={
                      handler.checkedBox?.[field.name]?.isChecked ?? true
                    }
                  />
                )}
              </>
            )}
          </>
        ))}
        <div
          className="col-md mt-4"
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "end",
            float: "right",
          }}
        >
          <button
            className="btn btn-primary mx-1"
            type="submit"
            onClick={(e) => handler.getList()}
            style={{
              height: "33px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              float: "right",
            }}
          >
            {props.showLoading && (
              <span className="spinner-border spinner-border-sm me-2"></span>
            )}
            Search
          </button>
          <button
            className="btn btn-primary mx-1"
            type="submit"
            onClick={(e) => handler.clearList()}
            style={{
              height: "33px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              float: "right",
            }}
          >
            Clear
          </button>
        </div>
      </div>
    </>
  );
};

export default Filter;
